import React, { SyntheticEvent } from "react";
import { logger } from "../../utils";
import styles from "./videoPlayback.css";
import {
  MediaPlaybackProps,
  MediaProps,
  StreamMetadata,
  withMediaStreamTrack
} from "./withMediaStreamTrack";

interface State {
  isVertical: boolean;
}

export interface VideoStreamMetadata extends StreamMetadata {
  width: number;
  height: number;
}

type VideoPlaybackProps = MediaProps & MediaPlaybackProps<VideoStreamMetadata>;

class VideoPlayback extends React.Component<VideoPlaybackProps, State> {
  private videoElement?: HTMLVideoElement;

  constructor(props: VideoPlaybackProps) {
    super(props);
    this.state = {
      isVertical: false
    };
  }

  componentDidMount() {
    logger.debug("VideoPlayback: Mounting component");
    if (this.videoElement) {
      logger.debug("VideoPlayback: Setting stream", this.props.stream);
      this.videoElement.srcObject = this.props.stream;
    }
  }

  componentDidUpdate(): void {
    // to refresh the stream, workaround for some freezing
    this.videoElement?.pause();
    this.videoElement?.play();
  }

  render() {
    logger.debug("Rendering VideoPlayback component");
    return (
      <video
        className={this.state.isVertical ? styles.vertical : styles.horizontal}
        playsInline
        autoPlay
        ref={this.setVideoRef}
        onLoadedMetadata={(e) => this.onVideoLoadedMetaData(e)}
      />
    );
  }

  private setVideoRef = (element: HTMLVideoElement) => {
    this.videoElement = element;
  };

  private onVideoLoadedMetaData = (e: SyntheticEvent<HTMLVideoElement>) => {
    const target = e.target as HTMLVideoElement;
    const isVertical = target.videoHeight > target.videoWidth;
    if (isVertical !== this.state.isVertical) {
      this.setState({ isVertical });
    }
    if (this.props.onMetadataChange) {
      this.props.onMetadataChange({ height: target.videoHeight, width: target.videoWidth });
    }
  };
}

export const VideoPlaybackWithTrack = withMediaStreamTrack<
  VideoStreamMetadata,
  MediaPlaybackProps<VideoStreamMetadata>
>(VideoPlayback);
